import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Radio } from "antd";
import { EUserRole, ServiceTemplateField, TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../../others/i18n.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
function FormFieldServiceTemplateShouldUncheckContentBlockerCheckbox({ options }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ServiceTemplateField.ShouldUncheckContentBlockerCheckbox,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(ServiceTemplateField.ShouldUncheckContentBlockerCheckbox, t),
            extra: t("If a content blocker is available, it is created by default."),
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
            children: ({ getFieldValue })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                    extendsFieldName: ServiceTemplateField.ShouldUncheckContentBlockerCheckbox,
                    disableStrategies: getDisableStrategies(),
                    onKeepContent: extended && /*#__PURE__*/ _jsx(Radio.Group, {
                        defaultValue: extended[ServiceTemplateField.ShouldUncheckContentBlockerCheckbox],
                        options: options,
                        optionType: "button",
                        buttonStyle: "solid",
                        disabled: true
                    }),
                    children: /*#__PURE__*/ _jsx(Form.Item, {
                        name: ServiceTemplateField.ShouldUncheckContentBlockerCheckbox,
                        noStyle: true,
                        children: /*#__PURE__*/ _jsx(Radio.Group, {
                            options: options,
                            optionType: "button",
                            buttonStyle: "solid"
                        })
                    })
                });
            }
        })
    });
}
export { FormFieldServiceTemplateShouldUncheckContentBlockerCheckbox };
